export const getOffer = (state) => state.offer.offer;

export const getOfferSelecting = (state) => state && state.offer ? state.offer.selecting : undefined;

export default { getOffer, getOfferSelecting };
